import type { Bonus } from '../types/content';

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Diesel Quick Diagnostic Checklists',
    description:
      'Organized inspection and troubleshooting checklists for no-starts, hard starting, low power, smoke, boost faults, DPF problems, and other common complaints.',
    use: 'Keep preliminary inspections and diagnostic checks organized.',
  },
  {
    number: '02',
    title: 'Diesel DTC & Live Data Field Guide',
    description:
      'A reference for organizing trouble-code information and live data, comparing commanded and actual values, and identifying relevant follow-up tests.',
    use: 'Connect scan information with the next diagnostic question.',
  },
  {
    number: '03',
    title: 'Diesel Test Results & Measurement Worksheets',
    description:
      'Worksheets for recording electrical, fuel, injector, boost, and aftertreatment measurements and comparing findings with manufacturer specifications.',
    use: 'Keep test results documented and easy to review.',
  },
  {
    number: '04',
    title: 'Diesel Symptom-to-Cause Troubleshooting Matrix',
    description:
      'A symptom-based reference for identifying relevant systems and possible causes to investigate in no-start, smoke, low-power, boost, and emissions complaints.',
    use: 'Organize possible causes before choosing the next check.',
  },
  {
    number: '05',
    title: 'Diesel Diagnostic Job Sheets & Case Report System',
    description: 'Documentation templates for complaints, evidence, test results, root causes, repairs, and post-repair verification.',
    use: 'Create a clear record of the diagnostic job.',
  },
];
